import { SxProps, Theme, Typography } from "@mui/material"

const Label = ({
  label,
  labelWeight,
  labelColor,
  required,
  labelSx,
  mb = 0.5
}: {
  label?: string
  labelWeight?: number
  labelColor?: string
  required?: boolean
  labelSx?: SxProps<Theme>
  mb?: number
}) => {
  if (label)
    return (
      <Typography
        color={labelColor ?? "primary"}
        sx={{ mb, display: "flex", alignItems: "center", fontWeight: labelWeight ?? 500, gap: 0.5, ...labelSx }}
        variant="subtitle1"
      >
        {label}{" "}
        {required && (
          <Typography color={"error"} lineHeight={0.75}>
            *
          </Typography>
        )}
      </Typography>
    )
  else <></>
}

export default Label
